// extracted by mini-css-extract-plugin
export default {"container":"CT9gQrLBErNzeNk2bQii"};